import { sdkRequest } from '@eventbrite/http';
import { LocationRequest } from '../types';

export const getLocationFromRequest = (): Promise<LocationRequest> =>
    sdkRequest('/api/v3/geo/place_from_request/');
